import React from "react";
import "./FreelancePage.css";
import "./App.css";

const ServiceCard = ({
  title,
  description,
  technologies,
  icon,
  features = [],
  pricing = null,
  timeline = null,
}) => {
  return (
    <div className="service-card">
      <div className="service-icon">{icon}</div>
      <h3 className="service-title">{title}</h3>
      <p className="service-description">{description}</p>

      {features.length > 0 && (
        <ul className="service-features">
          {features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      )}

      <div className="service-technologies">
        {technologies.map((tech, index) => (
          <span key={index} className="tech-tag">
            {tech}
          </span>
        ))}
      </div>

      {/* {pricing && (
        <div className="service-pricing">
          <span className="pricing-label">Starting from:</span>
          <span className="pricing-value">{pricing}</span>
        </div>
      )}

      {timeline && (
        <div className="service-timeline">
          <span className="timeline-label">Timeline:</span>
          <span className="timeline-value">{timeline}</span>
        </div>
      )} */}
    </div>
  );
};

// const ArchitectureDiagram = () => {
//   const [activeLayer, setActiveLayer] = useState(null);

//   const layers = [
//     {
//       id: "frontend",
//       name: "Frontend Layer",
//       technologies: ["React", "Flutter", "Golang", "SSR"],
//       description: "Modern, responsive user interfaces",
//     },
//     {
//       id: "gateway",
//       name: "API Gateway",
//       technologies: ["Cloudflare", "Rate Limiting", "Load Balancing"],
//       description: "Security and performance optimization",
//     },
//     {
//       id: "backend",
//       name: "Backend Microservices",
//       technologies: ["Golang", "Node.js", "gRPC", "REST APIs", "GraphQL"],
//       description: "Scalable, high-performance services",
//     },
//     {
//       id: "database",
//       name: "Database Layer",
//       technologies: ["PostgreSQL", "Redis", "MongoDB", "Neo4j"],
//       description: "Data persistence and caching",
//     },
//     {
//       id: "infrastructure",
//       name: "Infrastructure",
//       technologies: ["Docker", "AWS", "CI/CD", "Monitoring", "Backups"],
//       description: "DevOps and deployment automation",
//     },
//   ];

//   return (
//     <div className="architecture-diagram">
//       <h3>How Your App Works</h3>
//       <div className="layers-container">
//         {layers.map((layer, index) => (
//           <div
//             key={layer.id}
//             className={`layer ${activeLayer === layer.id ? "active" : ""}`}
//             onClick={() =>
//               setActiveLayer(activeLayer === layer.id ? null : layer.id)
//             }
//           >
//             <div className="layer-content">
//               <h4>{layer.name}</h4>
//               <p>{layer.description}</p>
//               <div className="layer-technologies">
//                 {layer.technologies.map((tech, techIndex) => (
//                   <span key={techIndex} className="layer-tech">
//                     {tech}
//                   </span>
//                 ))}
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

const ThirdPartyIntegrations = () => {
  const integrations = [
    {
      category: "Sign In Options",
      services: [
        {
          name: "Google Auth",
          description: "Sign in with Google account",
        },
        { name: "Apple Auth", description: "Sign in for Apple devices" },
        { name: "GitHub Auth", description: "Sign in for developers" },
      ],
    },
    {
      category: "Payments",
      services: [
        { name: "PayPal", description: "International payments" },
        { name: "Izyco", description: "Local payment for Turkey" },
        { name: "Shaparak", description: "Local payment for Iran" },
      ],
    },
    {
      category: "Communication",
      services: [
        { name: "Email", description: "Transactional emails" },
        { name: "SMS", description: "Text message notifications" },
        { name: "Location", description: "Geolocation services" },
      ],
    },
    {
      category: "Monitoring",
      services: [
        { name: "Sentry", description: "Error tracking & monitoring" },
        { name: "Logging Systems", description: "Centralized logging" },
      ],
    },
    {
      category: "AI Features",
      services: [
        { name: "Gemini APIs", description: "Google AI services" },
        { name: "ChatGPT APIs", description: "OpenAI integration" },
        { name: "AI Chat Systems", description: "Intelligent conversations" },
      ],
    },
    {
      category: "Blockchain",
      services: [
        { name: "Smart Contracts", description: "Automate agreements" },
        { name: "NFT Marketplace", description: "Buy and sell digital items" },
        { name: "NFT Creation", description: "Make your own NFTs" },
      ],
    },
  ];

  return (
    <div className="integrations-section">
      <h3>Connect With Popular Services</h3>
      <div className="integrations-grid">
        {integrations.map((category, index) => (
          <div key={index} className="integration-category">
            <h4>{category.category}</h4>
            <div className="integration-services">
              {category.services.map((service, serviceIndex) => (
                <div key={serviceIndex} className="integration-service">
                  <span className="service-name">{service.name}</span>
                  <span className="service-desc">{service.description}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const SecurityFeatures = () => {
  const securityFeatures = [
    {
      title: "Protection from Attacks",
      description: "Your app is safe from unwanted visitors",
      icon: "🛡️",
    },
    {
      title: "Limits on Usage",
      description: "Prevents anyone from overloading your app",
      icon: "⚡",
    },
    {
      title: "Secure Connection",
      description: "All your data is private and protected",
      icon: "🔒",
    },
    {
      title: "Safe Forms",
      description: "Checks all information entered is safe",
      icon: "✅",
    },
    {
      title: "Secure Login",
      description: "Extra steps to keep your account safe",
      icon: "🔐",
    },
    {
      title: "Error Alerts",
      description: "I get notified if something goes wrong",
      icon: "📊",
    },
    {
      title: "Backups",
      description: "Your data is saved regularly",
      icon: "💾",
    },
    {
      title: "Firewalls",
      description: "Extra layers of protection for your app",
      icon: "🔥",
    },
  ];

  return (
    <div className="security-section">
      <h3>Safety & Reliability</h3>
      <div className="security-grid">
        {/* {securityFeatures.map((feature, index) => (
          <div key={index} className="security-feature">
            <div className="security-icon">{feature.icon}</div>
            <h4>{feature.title}</h4>
            <p>{feature.description}</p>
          </div>
        ))} */}
      </div>
    </div>
  );
};

const ProcessTimeline = () => {
  const steps = [
    {
      phase: "Discovery Call",
      duration: "1-2 days",
      description:
        "We discuss your idea, goals, and requirements. I'll answer all your questions and provide honest feedback on timeline and budget.",
      activities: [
        "Understand your business needs",
        "Define project scope and features",
        "Provide transparent pricing and timeline",
      ],
    },
    {
      phase: "Build & Review",
      duration: "2-10 weeks",
      description:
        "I develop your app with regular check-ins so you can see progress and request changes. You stay involved throughout the process.",
      activities: [
        "Weekly progress updates with demos",
        "Your feedback shapes the final product",
        "Adjustments made along the way",
      ],
    },
    {
      phase: "Launch & Support",
      duration: "Ongoing",
      description:
        "I deploy your app and make sure it runs smoothly. After launch, I provide support to fix any issues and help with updates.",
      activities: [
        "Professional deployment to production",
        "Post-launch monitoring and support",
        "Available for updates and new features",
      ],
    },
  ];

  return (
    <div className="process-timeline">
      <h3>How We Work Together</h3>
      <div className="timeline-container">
        {steps.map((step, index) => (
          <div key={index} className="timeline-step">
            <div className="timeline-marker">
              <span className="step-number">{index + 1}</span>
            </div>
            <div className="timeline-content">
              <div className="step-header">
                <h4>{step.phase}</h4>
              </div>
              <p className="step-description">{step.description}</p>
              <ul className="step-activities">
                {step.activities.map((activity, activityIndex) => (
                  <li key={activityIndex}>{activity}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const FreelancePage = () => {
  const services = [
    {
      title: "Mobile Apps (iOS & Android)",
      description:
        "Beautiful mobile apps that work on both iPhone and Android phones. Your customers can download it from the App Store or Google Play.",
      technologies: ["Flutter", "IOS", "Android", "Sentry"],
      // icon: "📱",
      features: [
        "Works on iPhone and Android",
        "Available in app stores",
        "Fast and smooth performance",
        "Updates happen instantly",
      ],
      pricing: "$3,000+",
      timeline: "4-8 weeks",
    },
    {
      title: "Server & Database Systems",
      description:
        "The behind-the-scenes systems that power your app. Handles data storage, user requests, and keeps everything running smoothly 24/7.",
      technologies: ["Golang", "Node.js", "gRPC", "GraphQL", "Docker"],
      // icon: "⚙️",
      features: [
        "Handles thousands of users at once",
        "Secure data storage",
        "Fast response times",
        "Automatic backups",
        "Scales as you grow",
      ],
      pricing: "$2,000+",
      timeline: "2-5 weeks",
    },
    // {
    //   title: "Golang Backend Services",
    //   description:
    //     "High-performance backend microservices with RESTful APIs, real-time communication, and scalable architecture.",
    //   technologies: [
    //     "Golang",
    //     "gRPC",
    //     "PostgreSQL",
    //     "Redis",
    //     "Docker",
    //     "CI/CD",
    //   ],
    //   icon: "⚙️",
    //   features: [
    //     "Microservices architecture",
    //     "RESTful API development",
    //     "Real-time communication",
    //     "Database optimization",
    //     "Caching strategies",
    //     "Container deployment",
    //   ],
    //   pricing: "$2,500+",
    //   timeline: "3-6 weeks",
    // },
    {
      title: "Complete Websites & Web Apps",
      description:
        "Full-featured websites and web applications that work perfectly on computers, tablets, and phones. Everything you need in one package.",
      technologies: [
        "React",
        "Node.js",
        "Golang",
        "PostgreSQL",
        "Redis",
        "Docker",
      ],
      // icon: "🌐",
      features: [
        "Beautiful, responsive design",
        "Works on all devices",
        "Secure user accounts",
        "Fast loading speeds",
        "Easy to maintain",
        "Real-time updates",
      ],
      pricing: "$3,500+",
      timeline: "5-10 weeks",
    },
    {
      title: "Browser Extensions",
      description:
        "Custom tools that add features to Chrome or Firefox browsers. Perfect for productivity tools, shopping helpers, or content enhancers.",
      technologies: [
        "JavaScript",
        "Chrome API",
        "Firefox API",
        "WebExtensions",
      ],
      // icon: "🔌",
      features: [
        "Available in Chrome Web Store",
        "Available in Firefox Add-ons",
        "Easy for users to install",
      ],
      pricing: "$1,500+",
      timeline: "2-4 weeks",
    },
    {
      title: "Blockchain & NFTs",
      description:
        "Build your own NFT marketplace or create digital collectibles. Perfect for art, gaming, or digital assets that users can buy, sell, and trade.",
      technologies: ["Solidity", "Web3.js", "Ethereum", "IPFS", "MetaMask"],
      // icon: "⛓️",
      features: [
        "Create and sell NFTs",
        "Secure blockchain contracts",
        "Crypto wallet integration",
        "Marketplace features",
        "Digital ownership verification",
      ],
      pricing: "$3,500+",
      timeline: "4-8 weeks",
    },
    {
      title: "AI-Powered Applications",
      description:
        "Add smart AI features to your app like chatbots that answer questions, automatic content writing, or intelligent recommendations for users.",
      technologies: ["OpenAI API", "Gemini API"],
      // icon: "🤖",
      features: [
        "Smart chatbots for customer service",
        "Automatic content creation",
        "Personalized recommendations",
      ],
      pricing: "$2,800+",
      timeline: "3-6 weeks",
    },
    // {
    //   title: "Java Spring Boot Microservices",
    //   description:
    //     "Enterprise-grade microservices using Java Spring Boot with message queues and service discovery.",
    //   technologies: [
    //     "Java",
    //     "Spring Boot",
    //     "Kafka",
    //     "Eureka",
    //     "MongoDB",
    //     "Neo4j",
    //   ],
    //   icon: "☕",
    //   features: [
    //     "Spring Boot framework",
    //     "Kafka message queues",
    //     "Service discovery",
    //     "NoSQL databases",
    //     "Enterprise patterns",
    //     "Scalable architecture",
    //   ],
    //   pricing: "$2,800+",
    //   timeline: "4-8 weeks",
    // },
    // {
    //   title: "Flutter Package Development",
    //   description:
    //     "Custom Flutter packages published to pub.dev with comprehensive documentation and examples.",
    //   technologies: ["Flutter", "Dart", "pub.dev", "Documentation", "Examples"],
    //   icon: "📦",
    //   features: [
    //     "Package development",
    //     "pub.dev publishing",
    //     "Comprehensive documentation",
    //     "Live examples",
    //     "Version management",
    //     "Community support",
    //   ],
    //   pricing: "$1,200+",
    //   timeline: "2-3 weeks",
    // },
  ];

  return (
    <div className="container">
      <div className="freelance-header">
        <h1 className="title">Freelance Services</h1>
        <p className="freelance-subtitle">
          I help people and businesses bring their ideas to life with beautiful,
          easy-to-use apps and websites. No technical knowledge needed—I'll
          guide you every step of the way!
        </p>
      </div>

      <div className="services-section">
        <h3>What I Can Do For You</h3>
        <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>
      </div>

      {/* <div className="architecture-section">
        <div className="architecture-toggle-container">
          <button
            className="architecture-toggle-button"
            onClick={() => setShowArchitecture(!showArchitecture)}
          >
            {showArchitecture ? "Hide" : "Show"} Technical Details
            <span className="toggle-icon">{showArchitecture ? "▲" : "▼"}</span>
          </button>
        </div>
        {showArchitecture && <ArchitectureDiagram />}
      </div> */}

      <div className="integrations-section">
        <ThirdPartyIntegrations />
      </div>

      <div className="security-section">
        <SecurityFeatures />
      </div>

      <div className="process-section">
        <ProcessTimeline />
      </div>

      <div className="cta-section">
        <h2 className="subtitle">Ready to Get Started?</h2>
        <p className="cta-description">
          I can take care of everything for you—from your first idea to a
          finished product. Let's chat about what you need and how I can help!
        </p>
        <div className="cta-description">
          <span className="contact-label">Email:</span>
          <a href="mailto:danial@danials.org">danial@danials.org</a>
        </div>
        <div className="cta-buttons">
          <a href="/contact" className="cta-button primary">
            Get Started
          </a>
          <a href="/portfolio" className="cta-button secondary">
            View Portfolio
          </a>
        </div>
      </div>

      {/* <div className="contact-info">
        <h3>Contact Information</h3>
        <div className="contact-details">
          <div className="contact-item">
            <span className="contact-label">Email:</span>
            <a href="mailto:danial@danials.org">danial@danials.org</a>
          </div>
          <div className="contact-item">
            <span className="contact-label">Location:</span>
            <span>Mashhad, Iran (Remote work available)</span>
          </div>
          <div className="contact-item">
            <span className="contact-label">Availability:</span>
            <span>Available for new projects</span>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default FreelancePage;
